export const currencySymbols = {
  USD: "$",
  EUR: "€",
  OMR: "OMR",
};

export const pdfFileName = {
  1: {
    1: "Takaful Motor Insurance Policy",
    2: "Oman Qatar Motor Insurance Policy",
    4: "Gulf Motor Insurance Policy",
    5: "Orient Motor Insurance Policy",
  },
  15: {
    1: "Takaful Travel Insurance Policy",
    2: "Oman Qatar Travel Insurance Policy",
    4: "Gulf Travel Insurance Policy",
    5: "Orient Travel Insurance Policy",
  },
};
